angular.module('am4').directive('navigation', function() {
    return {
        restrict: 'A',
        controller: function() {
            this.openItem = null;
        },
        link: function(scope, element, attrs, controller) {
            angular.element(document.body).on('click', function() {
                controller.openItem = null;
                scope.$apply();
            });
        }
    };
}).directive('navigationButton', function() {
    var openClass = 'am4-navigation__button--open',
        numItems = 0;

    return {
        restrict: 'A',
        require: '^navigation',
        link: function(scope, element, attrs, navigationCtrl) {
            var item = numItems++;

            scope.$watch(function() {
                return navigationCtrl.openItem;
            }, function(openItem) {
                if (openItem === item) {
                    element.addClass(openClass);
                } else {
                    element.removeClass(openClass);
                }
            });

            element.on('click', function(e) {
                e.stopPropagation();
                if (element.hasClass(openClass)) {
                    navigationCtrl.openItem = null;
                    element.removeClass(openClass);
                } else {
                    navigationCtrl.openItem = item;
                    element.addClass(openClass);
                }
                scope.$apply();
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/navigation.js